import { LoginToken } from "model"
import { createContext } from "react"


export const tokenContext = createContext({
  token: "",
  updateToken: (loginToken: LoginToken) => { },
})